//@ts-nocheck
import { Fragment, useCallback, useEffect, useState } from 'react';
import { Menu, Transition } from '@headlessui/react';
import { useAppDispatch } from '../../app/hooks';
import { createTeamsPayload } from '../../features/pipelineStages/pipelineStagesTypes';
import { toast } from 'sonner';
import { createLocation, fetchPipelineStagesList, updateLocation } from '../../features/pipelineStages/pipelineStagesSlice';
import { Label, Listbox, ListboxButton, ListboxOption, ListboxOptions } from '@headlessui/react'
import {
  CheckCircleColorIcon, ChevronDownIcon, ChevronDownIconWhite, CustomCheckIcon,
  CustomPlusColorIcon, EllipsisHorizontalCircleColorIcon, XCircleColorIcon
} from '../icons';
import { baseTeamMemberInviteData } from '../../features/teams/teamsSlice';
import { useParams } from 'react-router-dom';
import { updateTeamMemberDetails } from '../../features/teamsMembers/teamsMemberSlice';
import { fetchJobPipelineDetailsData } from '../../features/hiringpipeline/hiringPipelineSlice';
import { assignJobPipelineDetailsData, fetchJobPipelineDetailsAssign } from '../../features/pipeline/pipelineSlice';
import { Dialog } from '@headlessui/react';
import { CrossIcon } from '../icons/Icons';
interface BoardPageProps {
  isModalOpen: boolean;
  setIsModalOpen: (value: boolean) => void;
  editBoardData?: any;
  baseId: number;
  setEditBoardData: (value: any) => void;
  userId: number;
}



function classNames(...classes: any) {
  return classes.filter(Boolean).join(' ')
}

const people = [
  { id: 1, name: 'admin' },
  { id: 2, name: 'manager' },
  { id: 3, name: 'member' }
];

// Add member permissions options
const memberPermissions = [
  { id: 1, name: 'View Candidates' },
  { id: 2, name: 'Edit Candidates' },
  { id: 3, name: 'Schedule Interviews' },
  { id: 4, name: 'Add Comments' },
  { id: 5, name: 'View Analytics' }
];


interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
  onSave?: (e: any) => void;
  loading?: boolean;
}

const Modal: React.FC<ModalProps> = ({ isOpen, onClose, title, children, onSave, loading }) => {
  return (
    <Transition.Root show={isOpen} as={Fragment}>
      <Dialog as="div" className="relative z-10" onClose={onClose}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
        </Transition.Child>

        <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
          <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              <Dialog.Panel className="relative transform rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl 
                            transition-all sm:my-8 sm:w-full sm:max-w-lg sm:p-4 overflow-visible max-h-[750px]">
                <div className="absolute right-0 top-0 hidden pr-4 pt-4 sm:block">
                  <button
                    type="button"
                    className="rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-none"
                    onClick={onClose}
                  >
                    <span className="sr-only">Close</span>
                    <CrossIcon />
                  </button>
                </div>
                <div className="sm:flex sm:items-start w-full">
                  <div className="mt-3 text-center sm:mt-0 sm:text-left w-full">
                    <Dialog.Title as="h3" className="text-base font-semibold leading-6 text-gray-900 capitalize">
                      {title}
                    </Dialog.Title>
                    <div className="mt-4">
                      {children}
                    </div>
                  </div>
                </div>
                <div className="mt-5 sm:mt-4 sm:flex sm:flex-row-reverse gap-2">
                  <button
                    type="button"
                    className=" inline-flex shrink-0  justify-center items-center gap-1 rounded-md bg-indigo-600 px-[14px] py-1 h-[32px] text-[13px] font-medium leading-6 text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                    disabled={loading}
                    onClick={onSave}
                  >
                    Save
                    {loading && (
                      <div className="simple-spinner">
                        <span></span>
                      </div>
                    )}
                  </button>
                  <button
                    type="button"
                    className="mt-3 inline-flex w-full justify-center items-center rounded-md bg-white px-[14px] py-2 text-[13px] h-[32px] font-medium text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:mt-0 sm:w-auto"

                    onClick={onClose}
                  >
                    Cancel
                  </button>
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  );
};

const EditHiringTeam: React.FC<BoardPageProps> = ({ isModalOpen, setIsModalOpen, editBoardData, baseId, setEditBoardData, userId, teamId, pipelineData, pipelineDataDetails, editIdSave, editUserId, setPipelineData }) => {
  const [email, setEmail] = useState('');
  const [purpose, setPurpose] = useState('');
  const [color, setColor] = useState('bg-[#3b82f6]');
  const [checked, setChecked] = useState(false);
  const [loading, setLoading] = useState(false);
  const [nameError, setNameError] = useState('');
  const [purposeError, setPurposeError] = useState('');
  const dispatch = useAppDispatch();
  const userStatus = localStorage.getItem('userDetails');
  const userStatusId = userStatus ? JSON.parse(userStatus) : null;
  const [baseTeamsData, setBaseTeamsData] = useState<any[]>([]);
  const [selected, setSelected] = useState(people[0])
  const { jobId } = useParams<{ jobId: string }>();
  const [role, setRole] = useState(null)
  const [selectedPermissions, setSelectedPermissions] = useState<typeof memberPermissions[0][]>([]);
  const [pipelineStages, setPipelineStages] = useState<any[]>([]);


  const colorList = [
    { name: "bg-[#3b82f6]" },
    { name: "bg-[#6b7280]" },
    { name: "bg-[#bfdbfe]" },
    { name: "bg-[#ec4899]" },
    { name: "bg-[#6366f1]" },
    { name: "bg-[#eab308]" },
    { name: "bg-[#22c55e]" },
    { name: "bg-[#06b6d4]" },
    { name: "bg-[#dc2626]" },
  ];

  // Modified useEffect to only fetch pipeline stages when 'member' role is selected
  useEffect(() => {
    const fetchPipelineStages = async () => {
      if (selected.role || selected.name === 'member') {
        try {
          const response = await dispatch(
            fetchJobPipelineDetailsAssign({
              baseId: parseInt(baseId, 10),
              userId: userStatusId?.id,
              JobId: jobId,
            })
          ).unwrap();

          const formattedStages = response.data.stages?.map((stage: any) => ({
            id: stage.id,
            name: stage.stage_name,
            color: stage.stage_colour,
            bucket: stage.bucket
          })) || [];

          setPipelineStages(formattedStages);
        } catch (error: any) {
          toast.error(error.message || "Failed to fetch pipeline stages");
        }
      } else {
        // Clear pipeline stages when non-member role is selected
        setPipelineStages([]);
        setSelectedPermissions([]);
      }
    };

    fetchPipelineStages();
  }, [selected.role, selected.name, dispatch, baseId, jobId, userStatusId?.id]);


  // Load edit data when available
  useEffect(() => {
    console.log("editBoardData in useEffect:", editBoardData);
    if (editBoardData) {      
      setEmail(editBoardData.email || '');
      setColor(`bg-[${editBoardData.color}]` || 'bg-[#3b82f6]');
      if (editBoardData) {
        setSelected(editBoardData);
      } else {
        setSelected(people[0]);
      }
    }
  }, [editBoardData]);


  useEffect(() => {
    const storedData = localStorage.getItem('basePiplineStagesData');
    if (storedData) {
      setBaseTeamsData(JSON.parse(storedData));
    }
  }, []);


  const handlePermissionToggle = (permission: typeof memberPermissions[0]) => {
    setSelectedPermissions(current => {
      const exists = current.find(p => p.id === permission.id);
      if (exists) {
        return current.filter(p => p.id !== permission.id);
      }
      return [...current, permission];
    });
  };

  const handleRemovePermission = (permissionId: number) => {
    setSelectedPermissions(current =>
      current.filter(permission => permission.id !== permissionId)
    );
  };

  const handleSave = async (e: any) => {
    e.preventDefault();
    setLoading(true);
    setNameError("");
    setPurposeError("");


    if (email.trim().length === 0) {
      setNameError("Email is required");
      setLoading(false);
      return;
    }
    // Check if bucket is selected
    if (!selected || !selected.name) {
      setPurposeError("Role is required"); // Assuming this error should be shown for bucket
      setLoading(false);
      return;
    }

    const colorValue = color.substring(color.indexOf("[#") + 1, color.indexOf("]"));




    try {

      if (editBoardData) {
        const payload: createTeamsPayload = {
          base_id: baseId,
          team_id: teamId,
          user_id: editUserId,
          role: selected.name,
          stage_id: selected.name === 'member' ? selectedPermissions.map(p => p.id).toString() : undefined

        };

        const response = await dispatch(updateTeamMemberDetails({
          baseId: editIdSave || pipelineDataDetails.teamMembers[0]?.id,
          data: payload
        })).unwrap()

        toast.success('Role updated successfully!');
        setIsModalOpen(false);
        if (response.status === 200) {
          const baseResponse = await dispatch(fetchJobPipelineDetailsData({
            baseId: Number(baseId),
            JobId: jobId
          }));

          if (baseResponse && baseResponse.payload) {
            const updatedPipelineData = baseResponse.payload;
            localStorage.setItem('jobByHiringTeamMembers', JSON.stringify(baseResponse.payload.data.teamMembers))
            const updatedMember = updatedPipelineData.data.teamMembers.map((member: any) => {

              const localStorageData = localStorage.getItem('jobByHiringTeamMembers');
              const baseMembers = localStorageData ? JSON.parse(localStorageData) : [];

              const invitedByMember = baseMembers.find((member1: any) =>
                member1.user_id === member.user_id
              );

              // Only update the role for the specific member we're editing
              if (member.id === editIdSave) {
                return {
                  ...member,
                  role: selected.name,
                  display_name: invitedByMember?.display_name,
                  email: invitedByMember?.email,
                  id: invitedByMember?.id,
                  name: invitedByMember?.name,
                  profile_pic: invitedByMember?.profile_pic,
                };
              }
              // Return the original member data for all other members
              return {
                ...member,
                display_name: invitedByMember?.display_name,
                email: invitedByMember?.email,
                id: invitedByMember?.id,
                name: invitedByMember?.name,
                profile_pic: invitedByMember?.profile_pic,
              };
            });

            setPipelineData(updatedMember);
          }
        }


      }

      else {
        // Create new team
        const response = await dispatch(
          baseTeamMemberInviteData({
            payload: {
              email,
              role: selected.name,
              team_id: pipelineDataDetails.id,
              ...(selectedPermissions.length > 0 && { stage_id: selectedPermissions.map((p) => p.id).toString() }),
            },
            userId: baseId,
            jobID: jobId, // Optional jobID
          })
        ).unwrap();



        // Now response contains the actual data
        toast.success('Hiring member add successfully');
        setIsModalOpen(false);

        if (response.status === 200) {
          // Fetch the latest pipeline details after updating the role
          const baseResponse = await dispatch(fetchJobPipelineDetailsData({ baseId: Number(baseId), JobId: jobId }));

          if (baseResponse && baseResponse.payload) {
            const updatedPipelineData = baseResponse.payload;  // Assuming the response contains the updated data
            localStorage.setItem('jobByHiringTeamMembers', JSON.stringify(baseResponse.payload.data.teamMembers))
            // Find the team member whose role was updated and set the role from response
            const updatedMember = updatedPipelineData.data.teamMembers.map((member: any) => {
              const localStorageData = localStorage.getItem('jobByHiringTeamMembers');
              const baseMembers = localStorageData ? JSON.parse(localStorageData) : [];


              const invitedByMember = baseMembers.find((member1: any) => member1.user_id === member.user_id);

              // Matching the member whose user_id is being updated
              if (member?.user_id === invitedByMember?.id) {  // Make sure selected has a user_id
                return {
                  ...member,
                  role: selected.name,
                  display_name: invitedByMember?.display_name,
                  email: invitedByMember?.email,
                  id: invitedByMember?.id,
                  name: invitedByMember?.name,
                  profile_pic: invitedByMember?.profile_pic,
                };
              }
              return member;
            });


            // Update the state with the new pipeline data, including the updated member
            setPipelineData(updatedMember);  // Update the teamMembers array
          }
        }
      }

      setIsModalOpen(false);
      resetForm();


    } catch (error) {
      console.error("Failed to save team:", error);
    } finally {
      setLoading(false);
    }
  };



  const resetForm = useCallback(() => {
    if (!editBoardData) { // Only reset if not editing
      setEmail('');
      setPurpose('');
      setSelectedPermissions([]);
      setPipelineStages([]); // Clear pipeline stages
      setSelected(people[0]);
    }
  }, [editBoardData]);

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    if (name === 'email') {
      setEmail(value);
      setNameError(value.trim().length === 0 ? "Email is required" : "");
    }
    else if (name === 'purpose') {
      setPurpose(value);
      // setPurposeError(value.trim().length === 0 ? "Description is required" : "");
    }
  };

  return (
    <Modal
      isOpen={isModalOpen}
      onClose={() => {
        setIsModalOpen(false);
        resetForm();
      }}
      title={editBoardData ? "Edit Hiring Team" : "Create Hiring team"}
      onSave={handleSave}
      loading={loading}
    >
      <form action="#" onSubmit={handleSave} className="space-y-6 mt-5">
        <div className='flex flex-col gap-y-2'>
          <label className='wg-label inline-flex cursor-pointer items-center
                     gap-1 text-sm font-medium leading-6'>Email</label>
          <div className="relative">
            <input
              id='email'
              name='email'
              type='email'
              disabled={!!editBoardData}
              autoComplete='email'
              value={email}
              onChange={handleInputChange}
              placeholder='Enter Email'
              className="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 disabled:cursor-not-allowed disabled:bg-gray-50 disabled:text-gray-500 disabled:outline-gray-200 sm:text-sm/6"
            />


          </div>
          {nameError && <p className="text-sm text-red-600">{nameError}</p>}



          <Listbox value={selected} onChange={setSelected}>
            <Label className="wg-label inline-flex cursor-pointer items-center gap-1 text-sm font-medium leading-6">Assign Role</Label>
            <div className="relative">
              <ListboxButton className="relative w-full cursor-default rounded-md bg-white py-1.5 pl-3 pr-10 text-left text-white-900 shadow-sm ring-1 
                        ring-inset ring-gray-300 focus:outline-none  sm:text-sm sm:leading-6">
                <span className="flex items-center capitalize">
                  {selected.role || selected.name}
                </span>
                <span className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2">
                  <ChevronDownIcon />
                </span>
              </ListboxButton>

              <ListboxOptions
                transition
                className="absolute top-[38px] z-10 mt-[2px] left-[0px] bg-white w-full max-w-full min-w-full rounded-lg border border-border
                           bg-popover p-1 text-popover-foreground shadow-lg shadow-black/5 data-[state=open]:animate-in data-[state=closed]:animate-out
                             data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95
                        data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2
                       data-[side=top]:slide-in-from-bottom-2"
              >
                {people.map((person) => (
                  <ListboxOption
                    key={person.id}
                    value={person}
                    className={({ active }) =>
                      classNames(
                        active ? 'bg-gray-200 text-[#1d2025]' : 'text-gray-900',
                        'relative flex cursor-default select-none items-center gap-2 rounded-md px-2 py-1.5 text-sm outline-none transition-colors focus:bg-accent focus:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50 [&_svg]:pointer-events-none [&_svg]:shrink-0'
                      )
                    }                  >
                    <span className="flex items-center">
                      <span className={`block truncate capitalize text-[14px]`} >
                        {person.name}
                      </span>
                    </span>
                  </ListboxOption>
                ))}
              </ListboxOptions>
              {purposeError && <p className="text-sm text-red-600">{purposeError}</p>}
            </div>
          </Listbox>
        </div>

        {(selected.role === 'member' || selected.name === 'member' &&
          <div className="mt-4">
            <label className="wg-label inline-flex cursor-pointer items-center gap-1 text-sm font-medium leading-6">
              Add stages
            </label>

            {/* Selected Stages Chips */}
            <div className="flex flex-wrap gap-2 mb-2">
              {selectedPermissions.map((stage) => (
                <div
                  key={stage.id}
                  className="inline-flex items-center gap-2 px-2 py-1 rounded-full bg-indigo-100 text-indigo-700 text-sm"
                >
                  {stage.name}
                  <button
                    type="button"
                    onClick={() => handleRemovePermission(stage.id)}
                    className="text-indigo-500 hover:text-indigo-700"
                  >
                    <XCircleColorIcon className="w-4 h-4" />
                  </button>
                </div>
              ))}
            </div>

            {/* Stages Dropdown */}
            <Listbox
              value={selectedPermissions}
              onChange={setSelectedPermissions}
              multiple
            >
              <div className="relative mt-1">
                <ListboxButton className="relative w-full cursor-default rounded-md bg-white py-1.5 pl-3 pr-10 text-left text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:outline-none sm:text-sm sm:leading-6">
                  <span className="block truncate">
                    Select stages
                  </span>
                  <span className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2">
                    <ChevronDownIcon />
                  </span>
                </ListboxButton>

                <ListboxOptions
                  className="absolute top-[38px] z-10 mt-[2px] left-[0px] bg-white w-full max-w-full min-w-full rounded-lg border border-border
                           bg-popover p-1 text-popover-foreground shadow-lg shadow-black/5 data-[state=open]:animate-in data-[state=closed]:animate-out
                             data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95
                        data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2
                       data-[side=top]:slide-in-from-bottom-2"
                >
                  {pipelineStages.map((stage) => (
                    <ListboxOption
                      key={stage.id}
                      value={stage}
                      className={({ active }) =>
                        classNames(
                          active ? 'bg-gray-200 text-[#1d2025]' : 'text-gray-900',
                          'relative flex cursor-default select-none items-center gap-2 rounded-md px-2 py-1.5 text-sm outline-none transition-colors focus:bg-accent focus:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50 [&_svg]:pointer-events-none [&_svg]:shrink-0'
                        )
                      }
                    >
                      {({ selected }) => (
                        <>
                          <div className="flex items-center justify-between gap-2">
                            <div className='flex items-center gap-x-2'>
                              <span className=' shrink-0 w-[9px] h-[9px] block rounded-full' style={{ background: stage.color }}>

                              </span>
                              <span className={`block capitalize truncate ${selected ? 'font-medium' : 'font-normal'}`}>
                                {stage.name}
                              </span>
                            </div>

                            <div className='ml-0'>
                              {
                                stage.bucket === 'inbox' &&
                                <span className="inline-flex items-center rounded-md bg-gray-50 px-2 py-1 text-xs font-medium text-gray-600 ring-1 ring-inset ring-gray-500/10">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width={16}
                                    height={16}
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="#4b5563"
                                    strokeWidth={2}
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    className="icon icon-tabler icons-tabler-outline icon-tabler-circle-plus text-[#4b5563] mr-2 w-[1rem] h-[1rem]"
                                  >
                                    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                                    <path d="M3 12a9 9 0 1 0 18 0a9 9 0 0 0 -18 0" />
                                    <path d="M9 12h6" />
                                    <path d="M12 9v6" />
                                  </svg>
                                  Inbox
                                </span>
                              }
                              {
                                stage.bucket === 'screening' &&
                                <span className="inline-flex items-center rounded-md bg-blue-50 px-2 py-1 text-xs font-medium text-blue-700 ring-1 ring-inset ring-blue-700/10">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width={16}
                                    height={16}
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="#4338ca"
                                    strokeWidth={2}
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    className="icon icon-tabler icons-tabler-outline icon-tabler-dots-circle-horizontal text-[#4338ca] mr-2 w-[1rem] h-[1rem]"
                                  >
                                    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                                    <path d="M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0" />
                                    <path d="M8 12l0 .01" />
                                    <path d="M12 12l0 .01" />
                                    <path d="M16 12l0 .01" />
                                  </svg>
                                  Screening
                                </span>
                              }
                              {
                                stage.bucket === 'hired' &&
                                <span className="inline-flex items-center rounded-md bg-green-50 px-2 py-1 text-xs font-medium text-green-700 ring-1 ring-inset ring-green-600/20">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width={16}
                                    height={16}
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="#15803d"
                                    strokeWidth={2}
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    className="icon icon-tabler icons-tabler-outline icon-tabler-circle-check text-[#15803d] mr-2 w-[1rem] h-[1rem]"
                                  >
                                    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                                    <path d="M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0" />
                                    <path d="M9 12l2 2l4 -4" />
                                  </svg>
                                  Hired
                                </span>
                              }
                              {
                                stage.bucket === 'reject' &&
                                <span className="inline-flex items-center rounded-md bg-red-50 px-2 py-1 text-xs font-medium text-red-700 ring-1 ring-inset ring-red-600/10">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width={16}
                                    height={16}
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="#b91c1c"
                                    strokeWidth={2}
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    className="icon icon-tabler icons-tabler-outline icon-tabler-circle-x text-[#b91c1c] mr-2 w-[1rem] h-[1rem]"
                                  >
                                    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                                    <path d="M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0" />
                                    <path d="M10 10l4 4m0 -4l-4 4" />
                                  </svg>
                                  Reject
                                </span>
                              }
                            </div>



                          </div>

                          {selected && (
                            <span className="absolute inset-y-0 right-0 flex items-center pr-3 text-indigo-600">
                              <CustomCheckIcon className="w-5 h-5" />
                            </span>
                          )}
                        </>
                      )}
                    </ListboxOption>
                  ))}
                </ListboxOptions>
              </div>
            </Listbox>
          </div>
        )}




      </form>
    </Modal>
  );
};

export default EditHiringTeam;